export const auth = {
  authHomeTitle: 'Pradėkime',
  authHomeButtonBranded: 'Tęsti su el. paštu',
  authHomeButtonApple: 'Tęsti su Apple',
  authHomeButtonGoogle: 'Tęsti su Google',
  authHomeButtonFacebook: 'Tęsti su Facebook',
  authHomeButtonLinkedin: 'Tęsti su LinkedIn',
  authStartTitle: 'Prisijungti arba registruotis',
  authStartInputTitle: 'El. paštas',
  authStartInputTitleError: 'Įveskite galiojantį el. pašto adresą!',
  authStartInputPasswordError: 'Įveskite galiojantį slaptažodį!',
  authWhoops: 'Oi!',
  authStartConfirmButton: 'Tęsti',
  authRegisteredTitle: 'Sveiki sugrįžę!',
  authStartPlaceholderTitle: 'El. paštas',
  authRegisteredInputTitle: 'Slaptažodis',
  authRegisteredForgotPassword: 'Pamiršote slaptažodį',
  authAlertIncorrectPassword: 'Neteisingas el. paštas arba slaptažodis',
  authAlertRequiredPassword: 'Įveskite galiojantį slaptažodį',
  authFinishSignUpTitle: 'Užbaikite registraciją',
  authFinishSignUpEmailInputTitle: 'El. paštas',
  authFinishSignUpFirstNameInputTitle: 'Vardas',
  authFinishSignUpLastNameInputTitle: 'Pavardė',
  authFinishSignUpPasswordInputTitle: 'Slaptažodis',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Rekomenduojame naudoti:</li><li class="list-disc">Bent 8 simbolius</li><li class="list-disc">Bent 1 skaičių</li><li class="list-disc">Bent 1 specialų simbolį</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Spustelėdami „Registruotis“ sutinkate su mūsų',
    privacyPolicy: 'Privatumo politika',
    text2: 'ir',
    termsOfUse: 'Naudojimo sąlygomis'
  },
  authFinishSignUpConfirmButton: 'Registruotis',
  authFinishSignUpErrorFirstName: 'Vardas negali būti tuščias!',
  authFinishSignUpErrorLastName: 'Pavardė negali būti tuščia!',
  authFinishSignUpErrorPassword: 'Slaptažodis per trumpas!',
  authEmailConfirmationTitle: 'Patikrinkite el. paštą',
  authEmailConfirmationContent:
    'Išsiuntėme patvirtinimo laišką jūsų el. pašto adresui. Jei nerandate jo gautųjų laiškų dėžutėje, patikrinkite šlamšto aplanką.',
  authEmailConfirmationConfirmButton: 'Grįžti į prisijungimą',
  authAlertEmailConfirmation: 'Patikrinkite el. paštą, kad patvirtintumėte adresą!',
  authResetPasswordTitle: 'Patikrinkite el. paštą',
  authResetPasswordDescription:
    'Išsiuntėme nuorodą slaptažodžiui atstatyti į jūsų el. paštą. Jei nerandate laiško, patikrinkite šlamšto aplanką.',
  authResetPasswordButton: 'Grįžti į prisijungimą',
  authNewPasswordTitle: 'Įveskite naują slaptažodį',
  authNewPasswordInputTitle: 'Naujas slaptažodis',
  authNewPasswordButton: 'Atstatyti slaptažodį',
  authNewPasswordAlertValidation: 'Slaptažodis per silpnas',
  authPasswordChangeSuccessTitle: 'Slaptažodis pakeistas!',
  authPasswordChangeSuccessContent: 'Slaptažodis sėkmingai pakeistas!',
  authPasswordChangeSuccessButton: 'Grįžti į prisijungimą',
  authPasswordChangeErrorTitle: 'Klaida!',
  authPasswordChangeErrorContent: 'Įvyko klaida bandant atstatyti slaptažodį. Pabandykite vėliau.',
  authPasswordChangeErrorButton: 'Grįžti į prisijungimą',
  authInvitationTitle: 'Pasirinkite slaptažodį',
  authInvitationInputTitle: 'Slaptažodis',
  authInvitationButton: 'Nustatyti slaptažodį',
  authEmailAddressConfirmed: 'El. pašto adresas patvirtintas!'
}
